import { useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";

const NotificationLikesPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState("");

    const { likeUsers = [] } = location.state || {};
    const trimmedSearchTerm = searchTerm.trim().toLowerCase();
    const filteredUsers = trimmedSearchTerm
        ? likeUsers.filter((user) => user.full_name?.toLowerCase().includes(trimmedSearchTerm))
        : likeUsers;

    return (
        <>
            <div className="sticky top-0 z-10 grid grid-cols-12 h-12 bg-[#BDE6FF] rounded-b-xl items-center px-2">
                <div className="col-span-2 flex justify-start">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="text-[24px] cursor-pointer text-black dark:text-black"
                    />
                </div>
                <div className="col-span-8 flex items-center justify-center">
                    <p className="text-center text-[16px] font-bold text-black dark:text-black">
                        Likes
                    </p>
                </div>
                <div className="col-span-2" />
            </div>

            <div className="relative m-2">
                <IoSearchOutline className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[18px] text-black dark:text-white" />
                <input
                    type="text"
                    value={searchTerm}
                    placeholder="Find people..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full text-[14px] pl-8 pr-2 py-1.5 rounded-lg bg-gray-100 dark:bg-[#333333] dark:text-white dark:placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#BDE6FF]"
                />
            </div>

            <div className="h-full overflow-y-auto pb-4">
                {filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                        <div
                            key={user.id}
                            onClick={() => navigate(`/account/${user.id}`)}
                            className="flex items-center gap-x-2 px-2 py-2 border-b last:border-b-0 border-gray-300 dark:border-gray-800/50 cursor-pointer"
                        >
                            <img
                                alt={user.full_name}
                                src={user.avatar_url}
                                className="w-9 h-9 rounded-full object-cover border border-gray-300 dark:border-gray-800/50"
                            />
                            <p className="text-[13px] font-semibold dark:text-white">
                                {user.full_name}
                            </p>
                        </div>
                    ))
                ) : (
                    <p className="text-center text-[12px] text-gray-500 mt-8">
                        {trimmedSearchTerm ? "No result found" : "No likes to show"}
                    </p>
                )}
            </div>
        </>
    );
};

export default NotificationLikesPage;
